import shared from 'Services/Shared'

export function notifyLinks() {
  const subscriptionLink = shared.getSubscriptionLink()

  if (subscriptionLink) subscriptionLink.onTokenChanged()
}
